declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function getFbp(): string | undefined {
  return getCookie("_fbp");
}

export function getFbc(): string | undefined {
  return getCookie("_fbc");
}

export function trackMetaEvent(
  eventName: string,
  params?: Record<string, unknown>
): string | undefined {
  const eventID = crypto.randomUUID();
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", eventName, params ?? {}, { eventID });
  }
  return eventID;
}
